import React, { ReactNode } from 'react'
import { T } from '@transifex/react'

import { createOptionsFromLabelMap } from '../../utils/create-options'

export type ScheduleAutomationActionTypes = `automatic` | `manual`

export const scheduleAutomationActionTypesLableMap: Record<
  ScheduleAutomationActionTypes,
  ReactNode
> = {
  manual: <T _str="Manual" />,
  automatic: <T _str="Automatic" />,
}

export const scheduleAutomationActionTypesOptions = createOptionsFromLabelMap(
  scheduleAutomationActionTypesLableMap
)
